<div class="modal-wrapper">
  <div class="modal-header">
    <p i18n="@@createbuilding.title">Create <strong>new building</strong></p>
    <i
      class="fas fa-times clickable"
      (click)="activeModal.dismiss('Cross click')"
    ></i>
  </div>
  <div class="modal-body">
    <div class="forms">
      <div class="addressInfo">
        <span class="form-title" i18n="@@createbuilding.formtitle.addressinfo"
          >Address info</span
        >
        <div class="form-wrapper">
          <form [formGroup]="createBuildingForm" class="addUserForm">
            <div class="row">
              <label class="col-md-6 formLabel">
                <ng-container i18n="@@general.street">Street</ng-container>
                <span class="required">*</span>
              </label>

              <div class="md-form col-md-6 form-group">
                <select
                  class="
                    form-control
                    browser-default
                    custom-select
                    md-select
                    form-select
                  "
                  formControlName="addressInfo"
                  (change)="changeStreet($event)"
                >
                  <option value="" disabled>Choose your street</option>
                  <option *ngFor="let info of addressInfo">
                    {{ this.getAddressInfoKey(info) }}
                  </option>
                </select>

                <span
                  *ngIf="
                    (createBuildingForm.get('street').touched ||
                      createBuildingForm.get('street').dirty) &&
                    createBuildingForm.get('street').errors
                  "
                  class="invalid-feedback"
                >
                  <span
                    *ngIf="createBuildingForm.get('street').errors.required"
                    i18n="@@validation.street.required"
                    >Please enter a street name.
                  </span>
                </span>
              </div>
            </div>

            <div class="row">
              <label class="col-md-6 formLabel"
                ><ng-container i18n="@@general.housenumber.short"
                  >House nr.</ng-container
                ><span class="required">*</span></label
              >
              <div class="md-form col-md-6 form-group">
                <input
                  type="text"
                  formControlName="number"
                  class="form-control"
                />
                <span
                  *ngIf="
                    (createBuildingForm.get('number').touched ||
                      createBuildingForm.get('number').dirty) &&
                    createBuildingForm.get('number').errors
                  "
                  class="invalid-feedback"
                >
                  <span
                    *ngIf="createBuildingForm.get('number').errors.required"
                    i18n="@@validation.housenumber.required"
                    >Please enter a house nr.</span
                  >
                  <span
                    *ngIf="createBuildingForm.get('number').errors.pattern"
                    i18n="@@validation.housenumber.invalid"
                    >House nr must be a number.</span
                  >
                </span>
              </div>
            </div>

            <div class="row">
              <label class="col-md-6 formLabel" i18n="@@general.suffix"
                >Suffix</label
              >
              <div class="md-form col-md-6 form-group">
                <input
                  type="text"
                  formControlName="suffix"
                  class="form-control"
                  oninput="this.value = this.value.toUpperCase()"
                />
                <span
                  *ngIf="
                    (createBuildingForm.get('suffix').touched ||
                      createBuildingForm.get('suffix').dirty) &&
                    createBuildingForm.get('suffix').errors
                  "
                  class="invalid-feedback"
                >
                  <span
                    *ngIf="
                      createBuildingForm.get('suffix').errors
                        .validateThreeAlphabeticCharacters
                    "
                    i18n="
                      @@validation.housesuffix.threealphabeticcharacters.invalid"
                    >House suffix can have a maximum of 3 alphabetic
                    characters.</span
                  >
                  <span
                    *ngIf="
                      createBuildingForm.get('suffix').errors
                        .validateThreeNumericCharacters
                    "
                    i18n="
                      @@validation.housesuffix.theenumericcharacters.invalid"
                    >House suffix can have a maximum of 3 numeric
                    characters.</span
                  >
                  <span
                    *ngIf="
                      createBuildingForm.get('suffix').errors
                        .validateOneAlphabeticAndThreeNumericCharacters
                    "
                    i18n="@@validation.housesuffix.onealphathreenumeric.invalid"
                    >House suffix can have one alphabetic character followed by
                    maximum 3 numeric characters.</span
                  >
                </span>
              </div>
            </div>

            <div class="row">
              <label class="col-md-6 formLabel"
                ><ng-container i18n="@@general.postalcode"
                  >Postal code</ng-container
                >
                <span class="required">*</span></label
              >
              <div class="md-form col-md-6 form-group">
                <input
                  type="text"
                  formControlName="postalCode"
                  class="form-control"
                />
                <span
                  *ngIf="
                    (createBuildingForm.get('postalCode').touched ||
                      createBuildingForm.get('postalCode').dirty) &&
                    createBuildingForm.get('postalCode').errors
                  "
                  class="invalid-feedback"
                >
                  <span
                    *ngIf="createBuildingForm.get('postalCode').errors.required"
                    i18n="@@validation.postalcode.required"
                    >Please enter a postal code.</span
                  >
                  <span
                    *ngIf="createBuildingForm.get('postalCode').errors.pattern"
                    i18n="@@validation.postalcode.invalid"
                    >Please enter a correct postal code.</span
                  >
                </span>
              </div>
            </div>

            <div class="row">
              <label class="col-md-6 formLabel"
                ><ng-container i18n="@@general.city">City</ng-container>
                <span class="required">*</span></label
              >
              <div class="md-form col-md-6 form-group">
                <input
                  type="text"
                  formControlName="city"
                  class="form-control"
                />
                <span
                  *ngIf="
                    (createBuildingForm.get('city').touched ||
                      createBuildingForm.get('city').dirty) &&
                    createBuildingForm.get('city').errors
                  "
                  class="invalid-feedback"
                >
                  <span
                    *ngIf="createBuildingForm.get('city').errors.required"
                    i18n="@@validation.city.required"
                    >Please enter a city.</span
                  >
                </span>
              </div>
            </div>

            <div class="row">
              <label class="col-md-6 formLabel" i18n="@@general.coordinates"
                >Coordinates</label
              >
              <div class="d-flex md-form col-md-6 form-group">
                <span class="colField">
                  <span class="absTitle" i18n="@@general.coordinates.x">X</span>
                  <input
                    type="number"
                    formControlName="coordinatesX"
                    class="form-control"
                  />
                </span>
                <span class="colField">
                  <span class="absTitle" i18n="@@general.coordinates.y">Y</span>
                  <input
                    type="number"
                    formControlName="coordinatesY"
                    class="form-control"
                  />
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="existingAddress">
        <span
          class="form-title"
          i18n="@@createbuilding.formtitle.existingaddesses"
          >Existing Addresses</span
        >
        <div
          class="existingAddressTree"
          *ngIf="matchingExistingAddresses.length > 0; else noMatchingAddresses"
        >
          <div
            class="addressFrame"
            *ngFor="let adress of matchingExistingAddresses"
            [ngClass]="{ active: selectedExistingAdress == adress }"
            (click)="chooseExistingAdress(adress)"
          >
            <span class="existingAddressTitle">
              <span class="existingAddressRow">{{ adress.street }}</span>
              <span class="existingAddressRow"
                >{{ adress.number }} {{ adress.suffix }}</span
              >
              <span class="existingAddressRow">{{ adress.city }}</span>
            </span>
          </div>
        </div>
        <ng-template #noMatchingAddresses>
          <span class="d-block noValue">{{
            formHasValue() == 0
              ? "Start typing in the address info panel to search for addresses"
              : "No address was found"
          }}</span>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="modal-footer" *ngIf="showSubmit">
    <div class="action-btn" (click)="onSubmit(true)">
      <img src="assets/Keen&Wise_save and start survey.png" />
    </div>
    <div class="action-btn" (click)="onSubmit(false)">
      <img src="assets/Keen&Wise_save_blue.png" />
    </div>
  </div>
</div>
